import { QueryTuple, useLazyQuery } from '@apollo/client';
import { GET_PLANNING_WEEK_DATA } from '@bechtel/client-gql';
import { PlanningFilterInput, PlanningWeekStats } from '@bechtel/types';

export function useWeekPlanQuery(): QueryTuple<
  { planningWeekStats: PlanningWeekStats[] },
  { input: PlanningFilterInput }
> {
  const response = useLazyQuery<{ planningWeekStats: PlanningWeekStats[] }, { input: PlanningFilterInput }>(
    GET_PLANNING_WEEK_DATA,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    }
  );
  return response;
}
